<template>
    <div v-if="showInfoModal">
        <b-modal v-model="showInfoModal"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')" @hide="settings.onCancelHandler">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onClose"></span>
            </template>

            <!-- :style="{ backgroundImage: 'url(' + require(`@/assets/icons/${settings.icon}`) + ')' }" -->
            <div class="modal-icon" v-if="settings.icon" :style="getIconStyle()"></div>
            <h2 class="modal-title">{{ settings.title }}</h2>
            <div class="modal-message">{{ settings.message }}</div>
            <div v-if="settings.secondaryMessage" class="modal-secondary-text">{{ settings.secondaryMessage }}</div>


            <div class="modal-input" v-if="settings.input">
                <label for="modal-input" v-if="settings.input.label">{{settings.input.label}}</label>
                <b-form-input id="modal-input" v-model="settings.input.value" :placeholder="settings.input.placeholder"
                              :disabled="settings.input.disabled" :type="settings.input.type ? settings.input.type : 'text'"></b-form-input>
            </div>

            <div v-if="settings.additionalInputs">
                <div class="modal-input additional-input" v-for="(input, index ) in settings.additionalInputs"
                     :key="index">
                    <label for="modal-input" v-if="input.label">{{input.label}}</label>
                    <b-form-input id="modal-input" v-model="input.value" :placeholder="input.placeholder"
                                  :disabled="input.disabled"></b-form-input>
                </div>
            </div>
            <div v-for="checkboxItem in settings.checkboxes" class="modalDialogCheckbox">
                <b-form-checkbox
                        v-model="checkboxItem.checked"
                >
                </b-form-checkbox>
                <span>
                    {{checkboxItem.title}}
                </span>
            </div>
            <div v-for="description in settings.descriptions" class="modalDialogDescription">
                <div :style="{
                    'font-size': `${description.font_size || 14}px`,
                    'line-height': `${description.line_height || 17}px`,
                }">{{description.text}}</div>
            </div>

            <template v-slot:modal-footer>
                <b-button v-if="settings.showCancelButton" variant="default" class="secondary" @click="onClose">
                    <template v-if="settings.cancelButtonText">{{ settings.cancelButtonText }}</template>
                    <template v-else>{{ translate('Cancel') }}</template>
                </b-button>

                <b-button v-if="settings.showAdditionalButton" variant="success" class="btn-primary"
                          @click="onAdditional">
                    <template v-if="settings.additionalButtonText">{{ settings.additionalButtonText }}</template>
                    <template v-else>Additional</template>
                </b-button>

                <b-button v-if="!settings.hideOkButton" class="btn-primary" variant="primary" @click="onOk">
                    <template v-if="settings.okButtonText">{{ settings.okButtonText }}</template>
                    <template v-else>{{translate('OK')}}</template>
                </b-button>
            </template>
            <div v-if="settings.addBusinessPopup">
                <selectBusinessFlow :settings="settings.selectBusinessFlowSettings"></selectBusinessFlow>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";
    import errorMixin from '@/mixins/errorMixin';
    import {mapMutations, mapState} from "vuex";
    import selectBusinessFlow from '@/components/owner-management/selectBusinessFlow.vue'

    export default {
        name: 'customModalDialog',

        mixins: [errorMixin],

        data() {
            return {
                showInfoModal: !_.isEmpty(this.settings),
            }
        },

        watch: {
            settings(newValue) {
                this.showInfoModal = !_.isEmpty(newValue)
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        components: {
            selectBusinessFlow
        },

        computed: {
            ...mapState({
            }),
        },

        methods: {

            ...mapMutations({
            }),


            getIconStyle() {
                if (this.settings.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/icons/${this.settings.icon}`) + ')'
                    }
                } else {
                    return null
                }
            },

            async onClose() {
                this.showInfoModal = false
                if (this.settings.onCancelHandler) {
                    try {
                        await this.settings.onCancelHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            async onOk() {
                this.showInfoModal = false
                if (this.settings.onOkHandler) {
                    try {
                        await this.settings.onOkHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            onAdditional() {
                this.showInfoModal = false
                if (this.settings.onAdditionalHandler) {
                    this.settings.onAdditionalHandler(this.settings)
                }
            },

        },
    }
</script>

<style>

    .modal-secondary-text {
        font-size: 12px;
        font-weight: 700;
        margin-top: 15px;
    }

    .custom-modal.leftAlign .modal-input {
        text-align: left;
    }

    .custom-modal .close-icon {
        position: static;
        cursor: pointer;
        width: 28px;
        height: 28px;
        background: url('../../assets/icons/ic_close_white.svg') 50% no-repeat;
    }

    .custom-modal .modal-title {
        font-size: 18px;
        font-weight: bold;
        color: #2F2F2F;
        text-align: center;
    }

    .custom-modal .modal-header {
        text-align: center;
        border: none;
        justify-content: flex-end;
        padding-bottom: 0;
    }

    .custom-modal.welcome-modal .modal-footer {
        flex-direction: column;
    }

    .custom-modal.welcome-modal .modal-footer > * {
        width: 100%;
        margin: 5px 0;
        text-decoration: none;
    }

    .custom-modal .modal-footer a {
        text-decoration: none;
    }

    .custom-modal .modal-footer {
        border: none;
    }

    .custom-modal .modal-message {
        font-size: 16px;
        color: #2F2F2F;
        max-width: 360px;
        margin: 15px auto 0;
        white-space: pre-wrap;
    }

    .custom-modal {
        text-align: center;
    }

    .modal-input {
        margin-top: 15px;
    }

    .modal-input input:focus {
        border-color: #2F2F2F;
        box-shadow: 0 0 0 0.2rem rgba(47, 47, 47, 0.25);
    }

    .custom-modal .btn {
        min-width: 140px;
        padding: 10px 12px;
        border-radius: 0;
        border: none;
        font-size: 14px;
        font-weight: bold;
        width: 100%;
    }


    .custom-modal .btn:not(:disabled):not(.disabled):active,
    .custom-modal .btn:active,
    .custom-modal .btn:active:focus,
    .custom-modal .btn:focus {
        border-radius: 6px;
        box-shadow: inset 0 2px 4px 0 rgba(0,0,0,0.24);
    }

    .custom-modal .modal-icon {
        width: 56px;
        height: 56px;
        margin: 0 auto;
        background-size: cover;
        margin-bottom: 15px;
    }

    .custom-modal .btn.btn-primary {
        background: #2F2F2F;
        color: #ffffff;
    }

    /**/
    .full-width--btn.large {
        min-width: 40vw;
        font-size: 0.7vw;
        transform: translateX(-50%);
        left: 50%;
    }

    .full-width--btn.large.custom-modal .modal-message {
        width: 90%;
    }

    .full-width--btn.custom-modal .btn {
        width: 100%;
    }

    @media screen and (max-width: 1000px) {
        .full-width--btn.custom-modal .modal-footer button {
            width: 100%;
            margin: 0;
            margin-top: 3vw;
        }

        .full-width--btn.custom-modal .modal-footer {
            border: none;
            flex-direction: column-reverse;
            /* width: 100%; */
        }
    }

    .modalDialogCheckbox {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 10px;

    }
    .modalDialogDescription {
        margin-top: 12px;
        text-align: start;
        white-space: pre-wrap;
    }

</style>
<style scoped>
    .bussiness-site__content {
        margin-top: -30px;
    }

</style>
